import React from 'react'

export default function Equipment() {
  return (
    <div>Equipment</div>
  )
}
